import type { NextPage } from "next";
import Head from "next/head";
import Image from "next/image";
import GraphGif from "../public/GraphLow2.gif";
import GraphImage from "../public/graphImage.png";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

const Home: NextPage = () => {
  return (
    <div>
      <Head>
        <title>Universal Graph</title>
        <meta name="description" content="Generated by create next app" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Header />

      <div className="flex flex-col justify-center items-center h-screen bg-black">
        <Image src={GraphImage} alt="index-gif" width={1500} height={4000} />

        <h1 className="text-5xl text-white font-semibold absolute ">
          Universal Graph Project
          <br />
        </h1>
        <h2 className="text-lg font-normal my-4">
          Create all types of 3D graphs
          <br />
        </h2>
        <a
          className="text-blue-500"
          href="https://universal-graph.vercel.app/graph/luisEGV-LORD6395"
        >
          Demo
        </a>
      </div>
      <div className="w-full h-full bg-black">
        <Image src={GraphGif} alt="index-gif" width={1500} height={500} />
      </div>
      <Footer />
    </div>
  );
};

export default Home;
